import React, { useEffect, useState } from "react";
import Spinner from "../../Spinner";
import { SkeletonDashboard } from "../../Skeleton";
import { useNavigate } from "react-router-dom";
import useDashboard from "../Controller/useDashboard.controller";
import CreateSession from "../../CreateSession/View/CreateSession";
import IntelliMeStartModal from "../../IntelliMe/View/IntelliMeStartModal";
import IntelliMeJoinModal from "../../IntelliMe/View/IntelliMeJoinModal";
// Lottie animation removed for now
import Navigation from "../../../Components/Navigation";
import { FaHome, FaUsers, FaBell, FaComments } from "react-icons/fa";
import FuntelliMeCard from "./FuntelliMeCard";
import "./Dashboard.css";
import "./IntelliMeCard.css";
function Dashboard() {
  const [user, setUser] = useState(null);
  const [isFetchingUser, setIsFetchingUser] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [showJoin, setShowJoin] = useState(false);
  const [showIntelliMe, setShowIntelliMe] = useState(false);
  const navigate = useNavigate();
  // Use custom hook for logic/handlers
  const {
    fetchUser
  } = useDashboard({
    setUser,
    navigate
  });
  useEffect(() => {
    let cancelled = false;
    const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
    if (!userId) {
      setIsFetchingUser(false);
      navigate('/auth');
      return () => {
        cancelled = true;
      };
    }

    (async () => {
      try {
        await fetchUser(userId);
      } finally {
        if (!cancelled) setIsFetchingUser(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [fetchUser, navigate]);
  function Modal({ children, onClose }) {
    return (
      <div className="dashboard-modal-overlay" onClick={onClose}>
        <div className="dashboard-modal" onClick={e => e.stopPropagation()}>
          <button className="dashboard-modal-close" onClick={onClose}>&times;</button>
          {children}
        </div>
      </div>
    );
  }
  if (isFetchingUser) {
    return (
      <div className="dashboard-root">
        <Navigation user={null} />
        <div className="dashboard-content">
          <aside className="dashboard-sidebar">
            <SidebarIcon icon={<FaHome />} label="Home" />
            <SidebarIcon icon={<FaComments />} label="Sessions" />
            <SidebarIcon icon={<FaUsers />} label="Friends" />
            <SidebarIcon icon={<FaBell />} label="Notifications" />
          </aside>
          <main className="dashboard-main">
            <SkeletonDashboard />
          </main>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="dashboard-root">
        <Navigation user={null} />
        <div className="dashboard-content">
          <aside className="dashboard-sidebar">
            <SidebarIcon icon={<FaHome />} label="Home" />
            <SidebarIcon icon={<FaComments />} label="Sessions" />
            <SidebarIcon icon={<FaUsers />} label="Friends" />
            <SidebarIcon icon={<FaBell />} label="Notifications" />
          </aside>
          <main className="dashboard-main">
            <div style={{ width: '100%', maxWidth: 720, textAlign: 'center', color: '#555' }}>
              <h2 style={{ marginBottom: 8 }}>Unable to load your account</h2>
              <div style={{ marginBottom: 16 }}>Please log in again.</div>
              <button className="intellime-btn" onClick={() => navigate('/auth')}>Go to Login</button>
            </div>
          </main>
        </div>
      </div>
    );
  }
  return (
    <div className="dashboard-root">
  {/* Shared Navigation Bar */}
  <Navigation user={user} />
      <div className="dashboard-content">
        {/* Sidebar */}
        <aside className="dashboard-sidebar">
          <SidebarIcon icon={<FaHome />} label="Home" />
          <SidebarIcon icon={<FaComments />} label="Sessions" />
          <SidebarIcon icon={<FaUsers />} label="Friends" />
          <SidebarIcon icon={<FaBell />} label="Notifications" />
        </aside>
        {/* Main Area */}
        <main className="dashboard-main">
          <div className="dashboard-cards-container">
            {/* FuntelliMe (Low) Card */}
            <FuntelliMeCard />
            {/* IntelliMe (High) Card */}
            <div className="intellime-card">
              <h2>IntelliMe (High)</h2>
              <p>Deep, meaningful conversations with guided questions and real-time pairing.</p>
              <button className="intellime-btn" onClick={() => setShowIntelliMe(true)}>Start IntelliMe</button>
              <button className="intellime-btn" style={{ marginLeft: 12 }} onClick={() => setShowJoin(true)}>Join Queue</button>
            </div>
          </div>
          {/* IntelliMe Start Modal */}
          {showIntelliMe && (
            <Modal onClose={() => setShowIntelliMe(false)}>
              <IntelliMeStartModal
                user={user}
                onSuccess={sessionId => {
                  setShowIntelliMe(false);
                  navigate(`/lobby/${sessionId}`);
                }}
                onClose={() => setShowIntelliMe(false)}
              />
            </Modal>
          )}
          {/* Modals for CreateSession and JoinSession */}
          {showCreate && (
            <Modal onClose={() => setShowCreate(false)}>
              <CreateSession user={user} onClose={() => setShowCreate(false)} />
            </Modal>
          )}
          {showJoin && (
            <Modal onClose={() => setShowJoin(false)}>
              <IntelliMeJoinModal
                user={user}
                onSuccess={sessionId => {
                  setShowJoin(false);
                  navigate(`/lobby/${sessionId}`);
                }}
                onClose={() => setShowJoin(false)}
              />
            </Modal>
          )}
        </main>
      </div>
    </div>
  );
}
export default Dashboard;
function SidebarIcon({ icon, label }) {
  const navigate = useNavigate();
  const handleClick = () => {
    if (label === "Sessions") {
      navigate("/sessions-searching");
    }
  };
  return (
    <div className="sidebar-icon" onClick={handleClick} style={label === "Sessions" ? { cursor: "pointer" } : {}}>
      {icon}
      <span className="sidebar-label">{label}</span>
    </div>
  );
}
